import { createSlice } from "@reduxjs/toolkit";

const orgSlice = createSlice({
  name: "org",
  initialState: {
    orgData: null,
  },
  reducers: {
    setOrgData: (state, action) => {
      state.orgData = action.payload;
    },
    clearOrgData: (state) => {
      state.orgData = null;
    },
  },
});

export const { setOrgData, clearOrgData } = orgSlice.actions;
export default orgSlice.reducer;
